import React from "react";

const STATUS_MAP = {
    active: { dot: "#1A4331", text: "KATLAS node active" },
    unconfigured: { dot: "#B8860B", text: "KATLAS unconfigured" },
    auth_rejected: { dot: "#8B0000", text: "KATLAS credential rejected" },
    unreachable: { dot: "#4A4A4A", text: "KATLAS node unreachable" },
    node_error: { dot: "#D32F2F", text: "KATLAS node error" },
    loading: { dot: "#7A7A7A", text: "KATLAS checking…" },
};

export const StatusPill = ({ status, label }) => {
    const s = STATUS_MAP[status] || STATUS_MAP.loading;
    const text = label || s.text;
    return (
        <div
            data-testid="katlas-status-pill"
            className="inline-flex items-center gap-2 border border-[var(--rule)] bg-white px-3 py-1.5"
            style={{ borderRadius: 0 }}
        >
            <span
                aria-hidden
                className="inline-block h-[7px] w-[7px]"
                style={{ background: s.dot, borderRadius: 0 }}
            />
            <span
                className="font-mono uppercase tracking-[0.14em]"
                style={{ fontSize: 10.5, color: "#0A0A0A" }}
            >
                {text}
            </span>
        </div>
    );
};

export default StatusPill;
